// Global
import React from 'react';

// Local
import { CardListing } from '@generated/CardListing/CategoryTiles.model';
import { ComponentParams, GetComponentServerProps } from '@sitecore-content-sdk/nextjs';
import { Themes } from 'lib/themes';
import { usePreambleFields } from 'components/helpers/Molecules/Preamble/Preamble.sitecore';
import { ContentOverride } from '../CardListingShared';

// Data fetching
import { SearchResponse } from 'lib/services/models/search-response';
import { CategoryTiles } from './CategoryTiles';
import {
  getContentListWithOverrides,
  CATEGORY_TILES_DEFAULT_ASPECT_RATIO,
} from 'lib/utils/components/content-list-data';

type CategoryTilesProps = Omit<CardListing.CategoryTiles.CategoryTiles_Component, 'params'> & {
  staticProps: CategoryTilesStaticProps | null;
  params?: ComponentParams;
};

const CategoryTilesContent = (props: CategoryTilesProps) => {
  const preambleFields = usePreambleFields({
    fields: props.fields,
  });

  const result = (
    <CategoryTiles
      {...preambleFields}
      theme={props.params?.theme as Themes}
      categories={props.staticProps?.result?.Results || []}
      contentOverrides={props.staticProps?.contentOverrides || {}}
      fallbackImageUrl={props.staticProps?.fallbackImageUrl}
      showSliderForMobile={props.fields?.showSliderForMobile?.value || false}
    />
  );
  return result;
};

export const Default = (props: CategoryTilesProps) => {
  return <CategoryTilesContent {...props} />;
};

type CategoryTilesStaticProps = {
  result: SearchResponse | null;
  contentOverrides: Record<string, ContentOverride>;
  fallbackImageUrl?: string;
};

export const getComponentServerProps: GetComponentServerProps = async (rendering, layoutData) => {
  return {
    staticProps: await getContentListWithOverrides(rendering, layoutData, {
      maxCards: 14,
      gridAspectRatio: CATEGORY_TILES_DEFAULT_ASPECT_RATIO,
    }),
  };
};
